import { FaHamburger } from 'react-icons/fa';
import Logo from '../assets/images/logos/logo-long-transparent.svg';
import IconComponent from './Icon';
import UserDropDown from './UserDropDown';
import { FiMenu } from "react-icons/fi";
import { useNavigate } from 'react-router-dom';


const NavBar = ({setOpen, open} : {setOpen: any, open: boolean}) => {
    const navigate = useNavigate();
    return (
        <div className="App-header z-10">
            <div className="flex items-center">
                <div className='cursor-pointer md:hidden'>
                    <IconComponent icon={FiMenu} width={20} color='#000' onClick={() => setOpen(!open)} />
                </div>
            <img src={Logo} className="App-logo pl-3 cursor-pointer" alt="logo" onClick={() => navigate('/')} />
            </div>
            <UserDropDown />
        </div>
    );
}

export default NavBar;